import {
  Carousel,
  IProps as ICarouselProps,
} from "@faire/deprecated-retailer-visitor-shared/components/Carousel/Carousel";
import {
  CarouselWithTitleShell,
  ICarouselWithTitleShellProps,
} from "@faire/deprecated-retailer-visitor-shared/components/Carousel/CarouselWithTitleShell";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import React, { ComponentType } from "react";
import styled from "styled-components";

type IStyledCarouselProps<T> = ICarouselProps<T>;

const StyledCarousel = styled(Carousel)<IStyledCarouselProps<unknown>>`
  grid-area: carousel;
  overflow: hidden;

  padding: 0;

  ${responsiveMediaQueries.tabletAndAbove} {
    padding: 0;
    overflow: unset;
  }
`;

export interface ICarouselWithTitleProps<T>
  extends ICarouselProps<T>,
    ICarouselWithTitleShellProps {}

export const CarouselWithTitle = <T,>({
  className,
  title,
  titleRight,
  leftAlignTitle,
  subtitle,
  seeAllLink,
  seeAllOnClick,
  dataTestId,
  header,
  increaseMobileRowSpacing,
  noLeftTitlePadding,
  titleTypography,
  innerRef,
  ...rest
}: ICarouselWithTitleProps<T>) => {
  const TypedCarousel = StyledCarousel as ComponentType<
    IStyledCarouselProps<T>
  >;
  const { isMobile } = useViewport();

  return (
    <CarouselWithTitleShell
      innerRef={innerRef}
      className={className}
      title={title}
      titleRight={titleRight}
      leftAlignTitle={leftAlignTitle}
      subtitle={subtitle}
      seeAllLink={seeAllLink}
      seeAllOnClick={seeAllOnClick}
      dataTestId={dataTestId}
      header={header}
      increaseMobileRowSpacing={increaseMobileRowSpacing}
      noLeftTitlePadding={noLeftTitlePadding}
      titleTypography={titleTypography}
    >
      <TypedCarousel
        {...rest}
        noWrap={isMobile || rest.useHorizontalScrollCarousel || rest.noWrap}
        itemGap={rest.itemGap}
      />
    </CarouselWithTitleShell>
  );
};
CarouselWithTitle.Container = CarouselWithTitleShell.Container;
CarouselWithTitle.Title = CarouselWithTitleShell.Title;
CarouselWithTitle.AuxiliaryTitle = CarouselWithTitleShell.AuxiliaryTitle;
CarouselWithTitle.Content = StyledCarousel;
